<template>
  <div>
    <div
      v-if="errors.length"
    >
      <div
        v-for="error in errors"
        :key="error.type"
      >
        <div
          v-if="!error.status && isBlurred || !error.status && manualValidate"
          class="Validation Validation--error error"
        >
          {{ error.message }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    manualValidate: {
      type: Boolean,
      default: false,
    },
    serverValidation: {
      type: String,
      default: '',
    },
    isBlurred: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showValidation: false,
    };
  },
};
</script>
